import { EventEmitter, Input } from "@angular/core";
import { AlertService } from "app/services";
import { SalesService, UserForSalesManagement, UserSalesMessage } from "app/services/sales.service";

export class MessageModalComponentViewModel {

	public isOpen: boolean = false;
	public scrollTop: number = 0;
	public user: UserForSalesManagement = new UserForSalesManagement();
	public messages: UserSalesMessage[] = [];
	public newMessage: String;

	public onMessageModifiedCallback: () => void;

	constructor(private salesService: SalesService, private alertService: AlertService) {
		
	}

	open(user: UserForSalesManagement) {
		
		this.user = user;
		let userId: number = this.user.userId;
		this.salesService.getUserSalesMessages(userId, (messages) => this.messages = messages);
		this.isOpen = true;
	}

	close() {
		this.isOpen = false;
		this.user = new UserForSalesManagement();
	}


	postMessage() {
		this.salesService.postMessage(
			this.user.userId,
			String(this.newMessage),
			() => {
				this.newMessage = null;

				this.salesService.getUserSalesMessages(this.user.userId, (messages) =>  {
					this.messages = messages
					
					if (this.onMessageModifiedCallback) {
						this.onMessageModifiedCallback();
					}

				});
			},
			(error: any) => {
				this.alertService.error(error);
			}
		);
	}

	deleteMessage(messageId: number) {
		this.salesService.deleteMessage(
			messageId,
			() => {
				this.newMessage = null;

				this.salesService.getUserSalesMessages(this.user.userId, (messages) =>  {
					this.messages = messages
					
					if (this.onMessageModifiedCallback) {
						this.onMessageModifiedCallback();
					}

				});
			},
			(error: any) => {
				this.alertService.error(error);
			}
		);
	}

	putMessage(message: UserSalesMessage) {
		message.message = message.tempMessage;

		this.salesService.putMessage(
			message.messageId,
			message.message,
			() => {
				this.newMessage = null;

				this.salesService.getUserSalesMessages(this.user.userId, (messages) =>  {
					this.messages = messages
					
					if (this.onMessageModifiedCallback) {
						this.onMessageModifiedCallback();
					}

				});
			},
			(error: any) => {
				this.alertService.error(error);
			}
		);
	}

	
}


// WEBPACK FOOTER //
// ./src/app/containers/user/modal/message-modal.viewmodel.ts